import { render, staticRenderFns } from "./exTimeout.vue?vue&type=template&id=3800d994&scoped=true"
import script from "./exTimeout.vue?vue&type=script&lang=js"
export * from "./exTimeout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800d994",
  null
  
)

export default component.exports